// List of logger categories

/* tslint:disable */

export let LogCat =
{	/* tslint:enable */
	AppWrapper: {
		Wrapper: "wrapper",
		Tabs: "tabs"
	},
	UI: {
		default: "ui",
		Menu: "ui.menu",
		SearchBox: "ui.SearcBox",
		SelecrtableList: "ui.SelectableList",
		TreeView: "ui.TreeView",
		TopBar: "ui.TopBar",
		AlgLogo: "ui.AlgLogo",
		NavigationMenu: "ui.NavigationMenu",
		DynamicMenu: "ui.DynamicMenu",
		DynamicMenuGroup: "ui.DynamicMenuGroup",
		DynamicMenutem: "ui.DynamicMenutem",
		UserDetails: "ui.UserDetails",
		NavigationBar: "ui.NavigationBar",
		NavigationBarGroup: "ui.NavigationBarGroup",
		NavigationBarItem: "ui.NavigationBarItem",
		SessionTabs: "ui.SessionTabs",
		SessionTab: "ui.SessionTab",
		ActionBar: "ui.ActionBar",
		ActionBarGroup: "ui.ActionBarGroup",
		Button: "ui.Button",
		FavoriteButton: "ui.FavoriteButton",
		ToggleButton: "ui.ToggleButton",
		SvgIconsDefinitions: "ui.SvgIconsDefinitions",
		SvgIcon: "ui.SvgIcon",
		LayoutBox: "ui.LayoutBox",
		NavigationBarExample: "ui.NavigationBarExample",
		SessionTabsExampleExample: "ui.SessionTabsExampleExample",
		tranDemo: "ui.tranDemo",
		Theme: 'ui.Theme',
		ThemeExample: 'ui.ThemeExample',
		ActionBarExample: "ui.ActionBarExample",
		ToggleButtonExample: "ui.ToggleButtonExample",
		SvgIconsExampleExample: "ui.SvgIconsExampleExample",
		Permissions: "ui.Permissions"
	},
	ActionsWizard: {
		General: "custonization.actions.wizrd"
	},
	AppShell: {
		Login: "shell.login",
		Route: "shell.route",
		Menu: "shell.actions",
		Window: "shell.window",
		Sessions: "shell.session",
		Chat: "shell.chat",
		ExternalForms: "shell.external.forms"
	}
	, User: {
		Credentials: "user.credentials",
	}

	, Comm: {
		Proxies: "proxies",
		browser: "browser"
	}

	, Utils: {
		StringInterporlation: "utils.string.interpolation",
		Events: "utils.event",
		AngularBridge: "utils.angular",
		Serialization: "utils.serialization",
		Async: "utils.async"
	}

	, InternalLog: {
		Decorator: "$log"
	}

	, R2ILoggerCategories: {
		Channel: "R2IChannel",
		General: "R2IGeneral",
		Lookup: "R2ILookup",
		Mapper: "R2IMapper",
		MappingFunction: "R2IMappingFunction",
		Performance: "R2IPerformance",
		Plugins: "R2IPlugins",
		Queue: "R2IQueue",
		Socket: "R2ISocket",
		WS: "R2IWS"
	}

	, R2DSLoggerCategories: {
		Lookup: "R2DSLookup"
	}

	, R2LIBLoggerCategories: {
		General: "R2LIBGeneral"
	}

	, RisAppServerCategories: {
		AppServer: "RisAppServer",
		Executer: "RisAppServerExecuter",
		Scheduler: "RisAppServerScheduler",
		Task: "RisAppServerTask",
		Alerts: "RisAppServerAlerts",
		FinalizationManager: "RisAppServerFinalizationManager",
		RisFinalizationTask: "RisFinalizationTask",
		RisAppServerWindowsService: "RisAppServerWindowsService",
		DocumentDistributionTask: "DocumentDistributionTask",
		PrintOrderTask: "PrintOrderTask",
		CriticalResultsNotoficationTask: "CriticalResultsNotoficationTask"
	}

	, RisSMSyncServerCategories: {
		SMSyncServer: "SMSyncServer"
	}

	, RisLockingCategories: {
		General: "RisLockingGeneral",
		Lock: "RisLockingAddLock",
		Refresh: "RisLockingRefresh",
		Unlock: "RisLockingUnlock",
		Proxy: "RisLockingProxy"
	}

	, RisUserContextCategories: {
		General: "RisUserContextGeneral",
		Address: "RisUserContextAddress",
		Proxy: "RisUserContextProxy",
		FavoriteWorklists: "FavoriteWorklists",
		CustomWorklistFavorites: "CustomWorklistFavorites"
	}

	, RisClinicalContextCategories: {
		General: "RisClinicalContextGeneral",
	}

	, Flags: {
		General: "Flags"
	}
	, RisWorklistCategories: {
		General: "RisWorklistGeneral",
		Components: "RisWorklistComponent",
		Proxy: "RisWorklistProxy",
		Events: "RisworklistEvents",
		Views: "RisworklistViews",
		MainNav: "RisworklistMainNav",
		DateFilter: "RisWorklistDateFilter",
		WorklistOrder: "RisWorklistCategories.WorklistOrder"
	}

	, RisSchedulingCategories: {
		General: "RisSchedulingGeneral",
		Scheduler: "RisSchedulingScheduler",
		Component: "RisSchedulingComponent",
		Proxy: "RisSchedulingProxy",
		Service: "RisSchedulingService",
		ModalityAvailabilityViewer: "ModalityAvailabilityViewer"
	}

	, LookupsCategories: {
		Infra: "Lookups",
		Procedures: "Procedures",
		OrganizationStructure: "OrganizationStructure",
		PersonResource: "PersonResource",
		SchedulingGroups: "SchedulingGroups",
		StudyGroupManager: "StudyGroupManager",
		ScheduleModalityGroupsManager: "ScheduleModalityGroupsManager",
		ModalityAvailabilityViewer: "ModalityAvailabilityViewer",
		ResourceExceptionsManager: "ResourceExceptionsManager",
		ModalityAvailabilityException: "ModalityAvailabilityException"
	}

	, ExceptionHandlerCategories: {
		Uncaught: "Uncaught",
	},
	PatientIdChange: "PatientIdUpdate"
	, Translate: {
		Load: "Load",
		MissingTranslation: "MissingTranslation"
	},
	Forms: {
		Load: "LoadForms",
		Iframe: "Iframe",
		ModalitySelection: "PerformedModality",
		ProtocolSelection: "Protocol",
		MaskedTextBox: "MaskedTextBox",
		LookupData: "LookupData",
		LookupSearch: "LookupSearchControl",
		HijriDate: "HijriDate",
		Interfacing: 'Interface',
		Tabs: "FormTabs",
		Inventory: {
			Autopopulation: "Forms.Inventory.Autopopulation"
		},
		DrawingTool: "DrawingTool"
	},
	Clinical: {
		Save: "ClinicalSave",
		Patient: {
			Form: "PatientForm",
			Id: "PatientId",
			Chart: "PatientChart",
			Merge: "Clinical.Patient.Merge"
		},
		Visit: {
			Form: "VisitForm"
		},
		Order: {
			Clone: "CloneOrder"
		}
	}
	, PatientSearch: {
		General: "PatientSearch"
	}
	, PatientSummary: {
		Component: "PatientSummaryComponent",
		Proxy: "PatientSummaryProxy"
	}
	, DW: {
		Mechanism: 'engine'
	}
	, QR: {
		Reader: 'qr.code.reader'
	},
	Cfg: {
		BadCfg: 'cfg.MissConfig'
	},
	ExternalService: {
		General: "ExternalServiceGeneral"
	},
	Session: {
		WorklistData: "SessionWorklistData"
	},
	TogetherSession: {
		General: "TogetherSession.General",
		Fields: "TogetherSession.Fields",
	},
	ExternalSession: {
		Main: "ExternalSessionMain",
		Messaging: "ExternalMessaging"
	},
	ManagementReports: {
		General: "ManagementReports",
		ScheduledReports: "ScheduledReports"
	},
	NavigationBarEditor: {
		NavbarEditor: "NavigationBarEditor.NavbarEditor"
	},
	Documents: {
		Distribution: "DocumentsDistribution",
		Editor: "Editor",
		View: "View"
	},
	Printing: {
		DefaultPrinters: "DefaultPrinters",
		Printing: "Printing"
	},
	Attachments: {
		Printing: "AttachmentsPrinting",
		IFrame: {
			Tiff: "IFrame.Viewer.Tiff",
			Iframe: "IFrame.Viewer.Iframe"
		}
	},
	PatientKioskEditor: {
		General: "PatientKioskEditor.General",
		Directions: "PatientKioskEditor.Directions",
		Messages: "PatientKioskEditor.Messages",
		Exceptions: "PatientKioskEditor.Exceptions",

		Services: {
			Proxy: "PatientKioskEditor.Services.Proxy",
			Data: "PatientKioskEditor.Services.Data",
			Validation: "PatientKioskEditor.Services.Validation",
			Images: "PatientKioskEditor.Services.Images",
		},
		KioskProfile: {
			General: "PatientKioskEditor.KioskProfile.General",
			Modalities: "PatientKioskEditor.KioskProfile.Modalities",
			Hours: "PatientKioskEditor.KioskProfile.Hours",
			Messages: "PatientKioskEditor.KioskProfile.Messages",
			Exceptions: "PatientKioskEditor.KioskProfile.Exceptions",
			ArrivalMethods: "PatientKioskEditor.KioskProfile.ArrivalMethods"
		}
	},
	MDTMeetings: {
		General: "MDTMeetingsGeneral",
		OrgStructure: "MDTMeetingsOrgStructureTreeView",
		Calendar: "MDTMeetingsCalendar"
	},
	Presentation: {
		Form: "PresentationForm"
	},
	Linking: {
		General: "Linking",
		StatusWarnings: "Linking.StatusWarning"
	},
	SystemNotification: "SystemNotification",
	CalculationsManager: {
		Execute: "CalculationsManager.Execute"
	},
	DynamicRuleManager: {
		General: "DynamicRuleManager",
		EvaluateCondition: "DynamicRuleManager.EvaluateCondition"
	},
	SemCommunication: {
		General: "SemCommunication",
		SemLogger: "SemLogger"
	},
	CustomWorklistManager: {
		DynamicSearchTree: "CustomWorklistManager.DynamicSearchTreeFieldPath"
	},
	CustomWorklistEditor: {
		General: "CustomWorklistEditor.General"
	},
	Together: {
		General: "Together.General",
		Candidates: "Together.Candidates"
	},
	PatientPurge: {
		General: "PatientPurge",
		Error: "PatientPurge.Error"
	},
	Validations: {
		WebSessionValidation: 'Validations.WebSessionValidations',
		ValidationRules: 'Validations.ValidationRules'
	},
	BlindRead: {
		Session: "BlindRead.Session",
	},
	Justification: {
		Session: "Justification.Session",
	},
	ProtocolTable: {
		General: "ProtocolTable.General",
		ProtocolTableXSpsCodeKey: "ProtocolTable.ProtocolTableXSpsCodeKey",
	},
	Metadata: {
		General: "Metadata.General",
	},
	PPS: {
		Session: "PPS.Session",
	},
	StudySearch: {
		General: "StudySerach.General"
	}

};
